'use client'

import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const getBreadcrumbElements = (pathname: string) => {
    const pathElements = (pathname || '').split('/').filter((e) => e)
    const breadcrumbElements = [
        { title: 'home', path: '/' },
        ...pathElements.map((element, index) => ({
            title: element,
            path: `/${pathElements.slice(0, index + 1).join('/')}`,
        })),
    ]

    return breadcrumbElements
}

export const Breadcrumbs: React.FC = () => {
    const pathname = usePathname()
    const breadcrumbElements = getBreadcrumbElements(pathname || '')

    return (
        <div className="max-w-full overflow-x-auto py-2 font-bold text-[12px] max-lg:text-sm mb-5 ml-8 flex w-full">
            {breadcrumbElements.map((item, index) => (
                <div key={item.path}>
                    <Link href={item.path} className="text-secondary hover:text-primary underline">
                        {item.title.toLowerCase()}
                    </Link>
                    {index < breadcrumbElements.length - 1 && (
                        <FontAwesomeIcon
                            icon={faAngleRight}
                            className="text-darkgray max-w-[9px] max-md:max-w-[7px] mx-1.5"
                        />
                    )}
                </div>
            ))}
        </div>
    )
}
